// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"af06a9ea","412":"7dfdf257"}[chunkId] + ".chunk.js";
};